<template lang="html">
  <div class="small-12 cell wide-btn"
       :tabindex="tabIndex"
       ref="button"
       :class="{ 'active': active }"
       @click="clicked"
       @keypress="clicked" >
    {{ buttonText }}
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: String,
      required: false,
    },
    buttonText: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: '191px',
    },
    height: {
      type: String,
      required: false,
    },
    isBold: {
      type: Boolean,
      required: false,
    },
    fontSize: {
      type: String,
      required: false,
    },
    tabIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  methods: {
    clicked() {
      this.$emit('clicked');
    },
  },
  mounted() {
    /* get the $ref for the select element and then assign the custom styles */
    if (this.width) {
      this.$refs.button.style.width = this.width;
    }
    if (this.height) {
      this.$refs.button.style.height = this.height;
      this.$refs.button.style.lineHeight = this.height;
      let borderRad = parseInt(this.height, 10) / 2;
      borderRad = `${borderRad}px`;
      this.$refs.button.style.borderRadius = borderRad;
    }
    if (this.isBold) {
      this.$refs.button.style.fontWeight = 'bold';
    }
    if (this.fontSize) {
      this.$refs.button.style.fontSize = this.fontSize;
    }
  },
};
</script>

<style lang="scss" scoped>
  $light-grey-text: #7B8B95;

  .wide-btn {
    border: solid 1px $light-grey-text;
    border-radius: 24px;
    color: $light-grey-text;
    cursor: pointer;
    font-size: 12px;
    height: 48px;
    letter-spacing: 2px;
    line-height: 24px;
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    max-width: 100%;
  }

  .wide-btn:hover {
    color: #fff;
    background-color: $light-grey-text !important;
  }

  @media only screen and (max-width: 800px) {
    .full-width-for-mobile {
        width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/RareWebButtonLight.vue